// Host resolves the workspace display name from the tenant registry at read time, so it can come back
// null/blank (billing row whose tenant record no longer exists). Fall back to the tenant code, which is
// always persisted on the billing row — mirrors SurveyResponsesTable's `tenantName || tenantCode`.
export interface WorkspaceNamed {
  tenantCode: string
  tenantName: string | null
}

export function resolveWorkspaceName(row: WorkspaceNamed): string {
  return row.tenantName?.trim() || row.tenantCode || ''
}

// Null-safe Workspace comparator (ZCR-2529): the previous inline sorter called
// `a.tenantName.localeCompare(...)` and threw on a null name. Coalescing here mirrors how the
// numeric Usage/Excess sorters already coalesce missing values with `?? -1`.
export function compareWorkspaceName(a: WorkspaceNamed, b: WorkspaceNamed): number {
  return resolveWorkspaceName(a).localeCompare(resolveWorkspaceName(b))
}
